import PropTypes from 'prop-types';
import moment from 'moment';

const Date = (props) => {
  const { children, format, time, timeFormat } = props;
  if(children && time) {
    return moment(children).format(timeFormat);
  }
  if(children) {
    return moment(children).format(format);
  }
  return 'No Date';
};

Date.propTypes = {
  children: PropTypes.string,
  format: PropTypes.string,
  time: PropTypes.bool,
  timeFormat: PropTypes.string,
};

Date.defaultProps = {
  children: null,
  format: 'D MMM YYYY',
  time: false,
  timeFormat: 'D MMM YYYY, h:mm a',
};

export default Date;



// WEBPACK FOOTER //
// ./src/components/Date.jsx